import { callApi } from 'src/core/callApi';
import { BOOKING_COM_MARKET_INSIGHTS_API_URL, LTR_COMP_API_URL } from 'src/utils/const';
import { convertApiCurrency } from './helper';

export const getBookingComData = async (
  requestBody: null | any,
  currency: string,
  setData: (data: any) => void,
  setStatus: React.Dispatch<React.SetStateAction<'fetching' | 'success' | 'failed' | null>>
) => {
  const url = BOOKING_COM_MARKET_INSIGHTS_API_URL;
  let data;
  setStatus('fetching');

  try {
    data = await callApi(url, { body: requestBody }, true, false, '', 'POST', true);

    const isCurrencyNeedsToBeConverted = currency !== 'USD';

    if (data.error) {
      setData(null);
      setStatus('failed');
    } else {
      setData(_ => (isCurrencyNeedsToBeConverted ? convertApiCurrency(data, currency) : data));
      setStatus('success');
    }
  } catch (error) {
    console.error('Error handling report:', error);
    setData(null);
    setStatus('failed');
  }
};

export const getLTRCompData = async (
  reportId: string,
  currency: string,
  setData: React.Dispatch<
    React.SetStateAction<{ data: any; status: 'fetching' | 'success' | 'failed' | null }>
  >
) => {
  const url = LTR_COMP_API_URL;
  setData({ data: null, status: 'fetching' });

  try {
    let data = await callApi(url, { queryParams: { id: reportId } }, true, false, '', 'GET', true);

    if (!data.status) {
      // LTR data doesn't exist
      setData({ data: null, status: 'failed' });
      return;
    }

    // Handle not_ready status with polling
    if (data.status === 'fetching') {
      for (let i = 0; i < 24; i++) {
        await new Promise(resolve => setTimeout(resolve, 5000));
        data = await callApi(url, { queryParams: { id: reportId } }, true, false, '', 'GET', true);
        if (data.status === 'success') break;
      }
    }

    // Set final result
    if (data.error || data.status !== 'success') {
      setData({ data: null, status: 'failed' });
    } else {
      const convertedData = currency !== 'USD' ? convertApiCurrency(data, currency) : data;
      setData({ data: convertedData, status: 'success' });
    }
  } catch (error) {
    console.error('Error handling report:', error);
    setData({ data: null, status: 'failed' });
  }
};
